import { useQuery } from '@tanstack/react-query'
import { llmReasoningApi } from '../api/client'
import './LLMCostTile.css'

export function LLMCostTile() {
  const q = useQuery({
    queryKey: ['llm-reasoning-usage'],
    queryFn: llmReasoningApi.usage,
    refetchInterval: 30000,
  })

  if (q.isLoading) {
    return (
      <div className="card llm-cost-tile">
        <h3>LLM cost · today</h3>
        <p className="llm-muted">Loading…</p>
      </div>
    )
  }
  if (q.isError || !q.data) {
    return (
      <div className="card llm-cost-tile">
        <h3>LLM cost · today</h3>
        <p className="llm-muted">Failed to load LLM usage.</p>
      </div>
    )
  }

  const u = q.data
  const dailyPct = u.daily_budget_usd > 0 ? (u.cost_today_usd / u.daily_budget_usd) * 100 : 0
  const hourPct =
    u.max_calls_per_hour > 0 ? (u.calls_last_hour / u.max_calls_per_hour) * 100 : 0

  return (
    <div className="card llm-cost-tile">
      <h3>LLM cost · today</h3>
      <div className="llm-cost-row">
        <span className="llm-cost-label">Spent</span>
        <span className="llm-cost-value">
          ${u.cost_today_usd.toFixed(2)} / ${u.daily_budget_usd.toFixed(2)}
        </span>
      </div>
      <div className="llm-cost-bar" aria-label="daily budget used">
        <div
          className="llm-cost-bar-fill"
          style={{ width: `${Math.min(100, dailyPct)}%` }}
        />
      </div>
      <div className="llm-cost-row">
        <span className="llm-cost-label">Calls last hour</span>
        <span className="llm-cost-value">
          {u.calls_last_hour} / {u.max_calls_per_hour}
        </span>
      </div>
      <div className="llm-cost-bar" aria-label="hourly rate used">
        <div
          className="llm-cost-bar-fill"
          style={{ width: `${Math.min(100, hourPct)}%` }}
        />
      </div>
      <p className="llm-muted llm-cost-foot">
        Monthly budget: ${u.monthly_budget_usd.toFixed(2)}
      </p>
    </div>
  )
}
